import React from 'react'
import { FilterProvider } from 'components/Filter/context'
import useRolesViews from 'hooks/useRolesViews'
import useFilterConfiguration from 'pages/Tasks/hooks/useFilterConfiguration'
import type { TaskStateT } from 'pages/Tasks/types'
import type { RouteComponentProps } from 'react-router-dom'
import TaskListHeader from 'redesign/components/organisms/headers/TaskListHeader'
import Page from 'redesign/components/templates/Page'
import { TASK_LIST_ROOT_ID } from './constants'
import TaskListPageContent from './task-list-page-content'
import { getUrlTaskState, getUrlTaskType } from './utils'

const TaskListPage: React.FC<RouteComponentProps<{ taskstate?: TaskStateT }>> = (props) => {
  const { match } = props
  const { taskstate } = match.params
  const { activeView, roles } = useRolesViews()
  const isOffice = activeView === roles.office

  const { configuration, loading: configLoading } = useFilterConfiguration(getUrlTaskState(taskstate), getUrlTaskType())

  if (configLoading) {
    return <Page rootId={TASK_LIST_ROOT_ID} header={<TaskListHeader isOffice={isOffice} />} />
  }

  return (
    <FilterProvider configuration={configuration} name="tasks">
      <TaskListPageContent configLoading={configLoading} />
    </FilterProvider>
  )
}

export default TaskListPage
